export default class ComponentConfig implements app.ticket.interfaces.IComponentConfig {
    public name: string;
    public componentFeatureConfig: app.ticket.interfaces.IComponentFeatureConfig;
    public constructor(name: string, componentFeatureConfig?: app.ticket.interfaces.IComponentFeatureConfig) {
        this.name = name;
        this.componentFeatureConfig = componentFeatureConfig;
    }
}
